<template>
  <v-layout row wrap>
    <v-flex xs12 sm6 md6 lg6 xl6>
      <v-dialog ref="dialog1" v-model="pickerFrom" :return-value.sync="time['from']" lazy full-width width="290px">
        <template slot="activator">
          <v-text-field v-model="time['from']" label="Time From" prepend-icon="access_time" readonly></v-text-field>
        </template>
        <v-time-picker v-if="pickerFrom" v-model="time['from']" full-width format="24hr" :max="maxTimeFrom">
          <v-spacer></v-spacer>
          <v-btn flat @click="pickerFrom = false">Cancel</v-btn>
          <v-btn flat @click="$refs.dialog1.save(time['from'])">OK</v-btn>
        </v-time-picker>
      </v-dialog>
    </v-flex>
    <v-flex xs12 sm6 md6 lg6 xl6>
      <v-dialog ref="dialog" v-model="pickerTo" :return-value.sync="time['to']" lazy full-width width="290px">
        <template slot="activator">
          <v-text-field v-model="time['to']" label="Time To" prepend-icon="access_time" readonly></v-text-field>
        </template>
        <v-time-picker v-if="pickerTo" v-model="time['to']" full-width format="24hr" :min=" isSameDate ? time['from'] : null" :max="maxTimeTo" >
          <v-spacer></v-spacer>
          <v-btn flat @click="pickerTo = false">Cancel</v-btn>
          <v-btn flat @click="$refs.dialog.save(time['to'])">OK</v-btn>
        </v-time-picker>
      </v-dialog>
    </v-flex>
    <v-spacer></v-spacer>
  </v-layout>
</template>

<script>
import moment from 'moment'; 
export default {
  data() {
    return {
      time: {
        from: null,
        to: null
      },
      pickerFrom: false,
      pickerTo: false
    }
  },
  props: {
    isSameDate: {
      type: Boolean,
      required: true
    },
    isMaxDateToday: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    currentTime() { 
      return moment().format('HH:mm'); 
    },
  },
  computed: {
    maxTimeTo() {
      return this.isMaxDateToday ? this.currentTime() : null;
    },
    maxTimeFrom() {
      // If timeTo is selected first then the fromTime becomes timeTo
      return this.isSameDate
        ? (this.time.to
            ? this.time.to
            : (this.isMaxDateToday ? this.currentTime() : null)
          )
        : null;
    }
  },
  watch: {
    time: {
      handler() {
        this.$emit('change:time', this.time)
      },
      deep: true
    }
  }
}
</script>
